import { LOCALES } from 'i18n/locales';

export const feedbackFormIntl = {
    [LOCALES.ENGLISH]: {
        'feedbackForm.title': 'Give feedback on the NUAR platform',
        'feedbackForm.subTitle': 'Satisfaction survey',
        'feedbackForm.ratingTitle': 'Overall, how would you rate your experience of using NUAR?',
        'feedbackForm.recommendTitle': 'How likely are you to recommend NUAR to a colleague?',
        'feedbackForm.easeOfUseTitle': 'Overall, how difficult or easy did you find using the NUAR platform?',
        'feedbackForm.generalFeedback': 'Please provide any general feedback with regards to NUAR below.',
        'feedbackForm.submitButton': 'Send feedback',
        'feedbackForm.additionalComments.validation.length': 'Additional comments must be {characterCount} characters or less',
        'feedbackForm.ariaSatisfactionLabel': 'satisfaction rating',
        'feedbackForm.ariaRecommendationLabel': 'recommendation rating',
        'feedbackForm.veryPoor': 'Very poor',
        'feedbackForm.excellent': 'Excellent',
        'feedbackForm.veryLikely': 'Very likely',
        'feedbackForm.notLikely': 'Not likely',
        'feedbackForm.veryEasy': 'Very easy',
        'feedbackForm.veryDifficult': 'Very difficult',
        'feedbackForm.additional.feedback': 'Do you wish to leave additional detailed feedback about a specific feature?',
        'feedbackForm.activityComments': 'Please provide any feedback with regards to the activity below.',
        'feedbackForm.activityType.label': 'Activity type',
        'feedbackForm.success.title': 'Feedback saved',
        'feedbackForm.chooseActivity': 'Choose activity'
    },
    [LOCALES.WELSH]: {
        'feedbackForm.title': 'Rhoi adborth ar blatfform NUAR',
        'feedbackForm.subTitle': 'Arolwg bodlonrwydd',
        'feedbackForm.ratingTitle': 'Yn gyffredinol, sut fyddech chi\'n sgorio eich profiad o ddefnyddio NUAR?',
        'feedbackForm.recommendTitle': 'Pa mor debygol ydych chi o argymell NUAR i gydweithiwr?',
        'feedbackForm.easeOfUseTitle': 'Yn gyffredinol, pa mor anodd neu hawdd oedd defnyddio\'r platfform NUAR?',
        'feedbackForm.generalFeedback': 'Rhowch unrhyw adborth cyffredinol ynghylch NUAR isod.',
        'feedbackForm.submitButton': 'Anfon adborth',
        'feedbackForm.additionalComments.validation.length': 'Rhaid i sylwadau ychwanegol fod yn {characterCount} nod neu lai',
        'feedbackForm.ariaSatisfactionLabel': 'sgôr boddhad',
        'feedbackForm.ariaRecommendationLabel': 'sgôr argymhelliad',
        'feedbackForm.veryPoor': 'Gwael iawn',
        'feedbackForm.excellent': 'Gwych',
        'feedbackForm.veryLikely': 'Tebygol iawn',
        'feedbackForm.notLikely': 'Ddim yn debygol',
        'feedbackForm.veryEasy': 'Hawdd Iawn',
        'feedbackForm.veryDifficult': 'Anodd iawn',
        'feedbackForm.additional.feedback': 'Ydych chi am adael adborth manwl ychwanegol am nodwedd benodol?',
        'feedbackForm.activityComments': 'Rhowch unrhyw adborth ynghylch y gweithgaredd isod.',
        'feedbackForm.activityType.label': 'Math o weithgarwch',
        'feedbackForm.success.title': 'Adborth wedi\'i arbed',
        'feedbackForm.chooseActivity': 'Dewis gweithgarwch'
    }
};
